export function syncReleaseRuleEngineResult(job, currentForm, result) {
  const data = result && result.data ? result.data : result
  if (!data || !Array.isArray(data.seaCargoDocs)) {
    return data
  }

  if (job) {
    job.seaCargoDoc = data.seaCargoDocs
  }

  if (currentForm && currentForm.uuid) {
    const currentDoc = data.seaCargoDocs.find(item => item.uuid === currentForm.uuid)
    if (currentDoc) {
      Object.assign(currentForm, currentDoc)
    }
  }

  return data
}

export async function triggerReleaseRuleEngineAfterSave(executeRuleEngine, jobUuid, logger = console) {
  if (!jobUuid || typeof executeRuleEngine !== 'function') {
    return
  }

  try {
    await executeRuleEngine({ jobUuid, model: 1 })
  } catch (err) {
    const normalizedError = err === undefined
      ? {
        message: 'executeRuleEngine rejected without an error payload',
        jobUuid,
        hint: 'Check the request interceptor for Promise.reject() branches without arguments.'
      }
      : err
    logger.error('triggerReleaseRuleEngineAfterSave failed', normalizedError)
  }
}
